import type { Locale } from "antd/es/locale";
import viVN from "antd/locale/vi_VN";

export const viVNLocale: Locale = {
  ...viVN,
  DatePicker: {
    ...viVN.DatePicker,
    // Keep Vietnamese placeholders consistent across pages.
    // @ts-ignore
    lang: {
      ...(viVN.DatePicker?.lang ?? {}),
      placeholder: "Chọn thời điểm",
      yearPlaceholder: "Chọn năm",
      quarterPlaceholder: "Chọn quý",
      monthPlaceholder: "Chọn tháng",
      weekPlaceholder: "Chọn tuần",
      rangePlaceholder: ["Ngày bắt đầu", "Ngày kết thúc"],
      rangeYearPlaceholder: ["Năm bắt đầu", "Năm kết thúc"],
      rangeQuarterPlaceholder: ["Quý bắt đầu", "Quý kết thúc"],
      rangeMonthPlaceholder: ["Tháng bắt đầu", "Tháng kết thúc"],
      rangeWeekPlaceholder: ["Tuần bắt đầu", "Tuần kết thúc"],
      shortWeekDays: ["CN", "Hai", "Ba", "Tư", "Năm", "Sáu", "Bảy"],
      shortMonths: [
        "Th1",
        "Th2",
        "Th3",
        "Th4",
        "Th5",
        "Th6",
        "Th7",
        "Th8",
        "Th9",
        "Th10",
        "Th11",
        "Th12",
      ],
    },
  },
};
